import { createContext, useContext, useState, type ReactNode } from "react";

export interface AddressDetails {
  streetNumber: string;
  streetName: string;
  zipcode: string;
  city: string;
  country: string;
  fullAddress: string;
  /** Where the address data came from: search selection, GPS geocode, or not yet set */
  source?: "search" | "gps";
  /** If an existence check found a match, this carries the DB address id */
  existingAddressId?: number | null;
}

interface AddressContextType {
  addressDetails: AddressDetails;
  setAddressDetails: (newDetails: AddressDetails) => void;
}

const defaultAddressDetails: AddressDetails = {
  streetNumber: "",
  streetName: "",
  zipcode: "",
  city: "",
  country: "",
  fullAddress: "",
  source: undefined,
  existingAddressId: null,
};

const AddressContext = createContext<AddressContextType | undefined>(undefined);

export function AddressProvider({ children }: { children: ReactNode }) {
  const [addressDetails, setAddressDetails] = useState<AddressDetails>(
    defaultAddressDetails
  );

  return (
    <AddressContext.Provider value={{ addressDetails, setAddressDetails }}>
      {children}
    </AddressContext.Provider>
  );
}

export function useAddress() {
  const context = useContext(AddressContext);
  if (context === undefined) {
    throw new Error("useAddress must be used within an AddressProvider");
  }
  return context;
}
